var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4.5 7.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#585858;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x3C_\\uB808\\uC774\\uC5B4_x3E_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.66,0H.85c-.47,0-.85.38-.85.85v5.71c0,.47.38.85.85.85h2.81c.47,0,.85-.38.85-.85V.85c0-.47-.38-.85-.85-.85ZM2.25,7.05c-.24,0-.44-.2-.44-.44s.2-.44.44-.44.44.2.44.44-.2.44-.44.44ZM3.89,5.19c0,.16-.13.29-.29.29H.9c-.16,0-.29-.13-.29-.29V.98c0-.16.13-.29.29-.29h2.71c.16,0,.29.13.29.29v4.21Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.665713ab22ec911ddc26eae7af537423.svg";
export { ForwardRef as ReactComponent };